import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop({ triggerScroll }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const target = document.getElementById(id);

      if (target) {
        window.setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, triggerScroll]);

  return null;
}

export default ScrollToTop;
